import { Tool } from '@/types/tool';
import MapContainer from './map/MapContainer';
import mapboxgl from 'mapbox-gl';

interface MapProps {
  tools: Tool[];
  onLocationSelect?: (location: { lat: number; lng: number; formattedAddress: string }) => void;
  selectedLocation?: { lat: number; lng: number };
  isSelectingLocation?: boolean;
  mapRef?: React.MutableRefObject<mapboxgl.Map | null>;
  isMobile?: boolean;
}

const Map = ({ tools, onLocationSelect, selectedLocation, isSelectingLocation, mapRef, isMobile }: MapProps) => {
  return (
    <MapContainer
      tools={tools}
      onLocationSelect={onLocationSelect}
      selectedLocation={selectedLocation}
      isSelectingLocation={isSelectingLocation}
      defaultCenter={{ lat: 39.8283, lng: -98.5795 }} // Center of US
      defaultZoom={isMobile ? 3 : 4} // Adjust zoom level based on device
      mapRef={mapRef}
      isMobile={isMobile}
    />
  );
};

export default Map;